<nb-card [nbSpinner]="false" nbSpinnerStatus="primary" class="card-box">
  <nb-card-header class="content-header">
    <nb-icon class="icon" icon="play-circle-outline" status="basic">
    </nb-icon>
    <span class="title">
      {{ modalTitle | translate }}
    </span>
    <nb-icon icon="question-mark-circle-outline" nbTooltipStatus="control" class="me-2 cursor-help"
      nbTooltip="{{'tooltips.print-file' | translate}}" nbTooltipPlacement="left">
    </nb-icon>
    <nb-icon class="close" icon="close-outline" (click)="cancel()">
    </nb-icon>
  </nb-card-header>

  <nb-card-body class="content-body">
    <nb-stepper orientation="horizontal" #stepper (stepChange)="handleStepChange($event)"
      [class.first-step-disabled]="disableFirstStep" [linear]="true">
      <nb-step [label]="'bulk.upload-file' | translate" [stepControl]="firstStepForm">
        <form [formGroup]="firstStepForm" class="step-container">
          <app-multiprint-first-step *ngIf="currentStep === 1" [transferResources]="transferResources"
            (finishStep)="onFinishFirstStep($event)" [@enterTrigger]="'fadeIn'"></app-multiprint-first-step>
        </form>
      </nb-step>
      <nb-step [label]="'bulk.file-preview' | translate" [stepControl]="secondStepForm">
        <form [formGroup]="secondStepForm" class="step-container">
          <app-multiprint-second-step *ngIf="currentStep === 2" [uploadData]="dataFromStepOne"
            (finishStep)="onFinishSecondStep()" (goBackStep)="goBackStep()" [@enterTrigger]="'fadeIn'">
          </app-multiprint-second-step>
        </form>
      </nb-step>
      <nb-step [label]="'device.files.select-devices' | translate" [stepControl]="thirdStepForm">
        <form [formGroup]="thirdStepForm" class="step-container">
          <app-multiprint-third-step *ngIf="currentStep === 3" [deviceType]="dataFromStepOne.modelType"
            [fileMaterials]="dataFromStepOne.materials" [uploadFileId]="dataFromStepOne.uploadId"
            (goBackStep)="goBackStep()" (finishStep)="onFinishThirdStep()" [onlyDeviceIds]="onlyDeviceIds"
            [@enterTrigger]="'fadeIn'">
          </app-multiprint-third-step>
        </form>
      </nb-step>
    </nb-stepper>
  </nb-card-body>
</nb-card>